import { render, staticRenderFns } from "./parklist.vue?vue&type=template&id=21b68a35&scoped=true"
import script from "./parklist.vue?vue&type=script&lang=js"
export * from "./parklist.vue?vue&type=script&lang=js"
import style0 from "./parklist.vue?vue&type=style&index=0&id=21b68a35&prod&scoped=true&lang=css"
import style1 from "./parklist.vue?vue&type=style&index=1&id=21b68a35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b68a35",
  null
  
)

export default component.exports